

const getters = {
  getMessages: (state) => (channelId = null) => {
  
    return state.messages
  },
  getImages: (state) => {
  
    return state.images
  },
  getUnreadMessages: (state, getters) => (channelId) => {
    return getters.getMessages(channelId).filter((message) => message.read == false).length
  },
  getContacts: (state) => {
    return state.users
  },
  getSending: (state) => {
    return state.sending
  },
  getHistoryMessages: (state) => {
   
   return state.cant_messages ==  state.returned_messages
      
  }
}

export default getters